<template>
    <b-container>
        <b-alert show variant="primary" class="text-center">
            <i class="fa fa-info-circle fa-2x fa-fw mr-2"></i>
            Elija una de las opciones disponibles de administración
        </b-alert>

        <b-row>
            <b-col cols="4">
                <div class="border bg-white mb-3 mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-activities' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-activities')"
                    >Actividades</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-activity-groups' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-activity-groups')"
                    >Grupos de actividades</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-stop-schedules' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-stop-schedules')"
                    >Ruta de paradas por grupos</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-geopoints' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-geopoints')"
                    >Hoteles y pickups</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-hotel-stop-groups' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-hotel-stop-groups')"
                    >Hoteles, paradas por grupos</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-subzones' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-subzones')"
                    >Resorts</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-pickupzones' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-pickupzones')"
                    >Subzonas de recogida</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-suprazones' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-suprazones')"
                    >Subzonas</a>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-bus-companies' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-bus-companies')"
                    >Compañías de bus</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-bus-companies-prices' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-bus-companies-prices')"
                    >Precios de compañías de bus</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-activity-duration-types' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-activity-duration-types')"
                    >Tipos de duración de actividades</a>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <div class="border bg-white mb-3 mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-guides' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-guides')"
                    >Listado de guías</a>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-export' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-export')"
                    >Exportación</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-secrets' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-secrets')"
                    >Secretos</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'admin-help' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Admin', 'admin-help')"
                    >Ayuda</a>
                </div>
            </b-col>
        </b-row>
        
    </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    methods: {
        async navigate(tab, option) {
            await this.$store.dispatch("layout/setActiveTabAndOption", {tab: tab, option: option})
        }
    },
    computed: {
      ...mapGetters(['activeTab', 'activeOption'])
    }
}
</script>